module.exports = __webpack_public_path__ + "static/devopsdday-61af2bf1f8bd640e74d38ff621db55cc.png";